module.exports = __webpack_public_path__ + "42ccb523041c384aee72a503c0bfa633.MP3";